import { render, staticRenderFns } from "./SeletorVencedorLote.vue?vue&type=template&id=5874072b&scoped=true"
import script from "./SeletorVencedorLote.vue?vue&type=script&lang=ts"
export * from "./SeletorVencedorLote.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874072b",
  null
  
)

export default component.exports